/**
 * Cabeçalho padrão de tela — GUPM-134.
 * Título (h1) + subtítulo opcional + slot de ação à direita.
 *
 * Consolida o `<header><h1 text-2xl font-black text-jf-yellow>` que cada tela
 * reimplementava à mão (com deriva de margem/emoji/cor). Regra de uso:
 * subtítulo só quando carrega informação que o título não dá (recorte ativo,
 * última atualização, status ANM…), nunca só pra repetir o título.
 */
import type { ReactNode } from 'react';

export interface PageHeaderProps {
  title: ReactNode;
  /** Opcional — inclua apenas quando disser algo que o título não diz. */
  subtitle?: ReactNode;
  /** Slot à direita (ex.: botão de ação da tela). */
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({ title, subtitle, actions, className = '' }: PageHeaderProps) {
  return (
    <header className={`mb-4 flex items-start justify-between gap-3 flex-wrap ${className}`}>
      <div>
        <h1 className="text-2xl font-black text-jf-yellow">{title}</h1>
        {subtitle && <p className="text-jf-muted text-sm mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="shrink-0">{actions}</div>}
    </header>
  );
}
